import * as React from 'react';
import { Row } from '../Row';
import { selectCheckoutDetails } from '../../../../selectors/publishTerms';
import { useSelector } from 'react-redux';
import { formatPrice } from '../../../../utils/publishTerms';
import { IDetailContainerProps } from './types';

export const DetailContainer = (props: IDetailContainerProps) => {
  const { index } = props;

  const details = useSelector(selectCheckoutDetails);
  const detail = details[index];

  if (!detail) {
    return null;
  }

  const { name, price, periodInDays, discount, discountDescription, note } = detail;

  const priceValue = formatPrice({ price, days: periodInDays });
  const discountValue = discount > 0 ? formatPrice({ price: -discount }) : null;

  return (
    <>
      <Row name={name} value={priceValue} note={note} />
      {!!discountValue && <Row isDiscount name={discountDescription || 'Скидка'} value={discountValue} />}
    </>
  );
};
